import React from 'react';
import _ from 'lodash';
import { jobService } from '../_services';
import styles from './UserPreferencesEditForm.module.css';

class PrintLabelFormatDropdown extends React.Component {

    constructor(props) {
        super(props);

        var printLabelFormats = props.printLabelFormats;

        var initialState = {
            printLabelFormats: printLabelFormats
        }

        this.state = initialState;
    }

    render() {
        return (
            <select className="form-control" name={this.props.name} value={this.props.selectedValue} onChange={this.props.onChange}>
                {
                    this.props.includeBlank &&
                    <option value={""}></option>
                }
                {
                    this.state.printLabelFormats?.map((lf, index) => {
                        return  <option key={lf.code} value={lf.code}>{lf.description}</option>
                    })
                }
            </select>
        );
    }
}

export default class UserPreferencesEditForm extends React.Component {

    constructor(props) {
        super(props);

        var initialState = {
            default_printer_label: "",
        };

        Object.assign(initialState, {
            default_printer_label: (props.userPreferences?.defaultPrintLabelFormat || "")
        });

        this.state = initialState;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: (event.target.type === 'checkbox') ? event.target.checked: event.target.value
        })
    }

    handleSubmit(event) {
        event.preventDefault();

        if (this.props.onSubmit) {
            this.props.onSubmit(event, {
                defaultPrintLabelFormat: this.state.default_printer_label
            });
        }
    }

    handleCancel(event){
        if (this.props.onCancel) {
            this.props.onCancel(event);
        }
    }

    render() {
        return (
            <form id="userPreferencesEditForm" styleName="styles.form" onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col-xs-12 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
                        <div className="form-group form-group-sm">
                            <label>Default Print Label Format</label>
                            {this.props.printLabelFormats &&
                                <PrintLabelFormatDropdown
                                    name={"default_printer_label"}
                                    printLabelFormats={this.props.printLabelFormats}
                                    includeBlank={true}
                                    selectedValue={this.state.default_printer_label} onChange={this.handleChange} />
                            }
                        </div>
                        <button type="submit" className="btn btn-default btn-dl-green">SAVE</button>
                        <button type="button" className="btn btn-defualt btn-dl-green margin-lr10" onClick={this.handleCancel}>CANCEL</button>
                    </div>
                </div>
            </form>
        );
    }
}